module.exports = __webpack_public_path__ + "img/xingxing_icon.393a7e36.png";